<template>
  <div>
    <van-dialog
          :value="visible"
          @input="$emit('update:visible', $event)"
          title="配穴分工"
          :show-cancel-button="false"
          :show-confirm-button="false"
          class="acupoint-allocation-dialog"
          close-on-click-overlay
      >
          <div class="dialog-close-btn" @click="handleClose">×</div>
          <div class="dialog-content">
              <div class="head">
                <div class="info" style="width: 65%;">
                  <div class="text" style="font-size: 16px;">{{uname }}</div>
                  <div  class="text">
                    <span>{{usex }}</span>
                    <span> {{uage}}</span>
                    <span>{{uphone}}</span>
                  </div>

                </div>
                <div class="info" style="width: 50%;margin-left: 35px;">
                  <div class="text">工号：{{ dispname }}</div>
                </div>
              </div>

              <div class="acupoint-input-area">
                  <textarea
                      v-model="acupointText"
                      class="acupoint-textarea"
                      maxlength="500"
                      placeholder="请输入穴位方案信息"
                  ></textarea>
                  <div class="acupoint-tip">
                      <span class="tip-icon">ⓘ</span>
                      不同穴位请按空格/逗号/顿号进行分割
                  </div>
              </div>

              <div class="btn-group">
                  <button class="btn btn-outline" @click="openTemplateDialog">配穴模板</button>
                  <button class="btn btn-primary" @click="saveTemplateThenSaveAllocation">保存配穴方案</button>
              </div>

              <div class="save-template-row">
                <van-checkbox v-model="saveToTemplate">
                  同时保存到配穴模板
                </van-checkbox>
              </div>

            <div class="doctor-list">
              <!-- group 只存在一次 -->
              <van-radio-group v-model="mainPhysician" @change="handleMainChange">

                <div
                    class="doctor-item"
                    v-for="(doctor, index) in dataList"
                    :key="doctor.username"
                >
                  <div class="doctor-header">
                    <div class="doctor-name-box">
                        <div class="doctor-name">{{ doctor.dispname }}</div>

                        <div class="delete-btn" @click="deleteDoctor(index)">
                          <span class="delete-icon">🗑</span>
                          删除
                        </div>
                    </div>


                    <!-- 每个医生只放一个 radio -->
                    <van-radio
                        :name="doctor.username"
                        class="main-physician-radio"
                    >
                      主理疗师
                    </van-radio>
                  </div>

                  <div class="acupoint-check-group">
                    <div class="checkbox-row">
                      <van-checkbox
                          v-if="points && points.length > 0"
                          :value="isAllSelected(doctor)"
                          @click="toggleAll(doctor, index)"
                      >
                        全选
                      </van-checkbox>

                      <van-checkbox
                          v-for="acupoint in points"
                          :key="acupoint"
                          :value="doctor.pointlist.includes(acupoint)"
                          class="checkbox-item"
                          @click="togglePoint(doctor, acupoint)"
                      >
                        {{ acupoint }}
                      </van-checkbox>
                    </div>
                  </div>
                </div>

              </van-radio-group>
            </div>

              <div class="bottom-btn-group">
                  <button v-if="!hideAddDoctorButton" class="btn btn-outline btn-large"  @click="openDoctorDialog">加执行人</button>
                  <button class="btn btn-primary btn-large" @click="saveAcupointAllocation()">保存配穴分工</button>
              </div>
              <div class="save-template-row" style="color: #999">
                若配穴方案有变动，请先保存方案并重新分工后，再保存分工信息。
              </div>
          </div>
      </van-dialog>

      <van-dialog
          v-model="doctorDialogVisible"
          title="选择执行人"
          show-cancel-button
          append-to-body
          @confirm="handleDoctorConfirm"
      >
        <div class="doctor-select-list">
          <template v-if="doctorList && doctorList.length > 0">
            <div
                v-for="item in doctorList"
                :key="item.username"
                class="doctor-select-item"
                :class="{
          active: isSelected(item),
          disabled: isDisabled(item)
        }"
                @click="handleDoctorClick(item)"
            >
              <span v-if="item.ishelp == 1">(助)</span>{{ item.dispname }}
            </div>
          </template>

          <div v-else class="empty-doctor-tip">
            暂无签到理疗师，请提醒理疗师在手机工作台上进行签到
          </div>
        </div>
      </van-dialog>

      <van-dialog
          v-model="templateDialogVisible"
          title="配穴模板"
          show-cancel-button
          append-to-body
          @confirm="handleTemplateConfirm"
          class="template-dialog"
      >
        <div class="template-search">
          <van-field
              v-model="templateKeyword"
              placeholder="请输入模板内容搜索"
              clearable
              @keyup.enter="searchTemplate"
          />
          <van-button type="primary" size="small" @click="searchTemplate">
            搜索
          </van-button>
        </div>

        <div class="template-list">
          <!-- 有数据 -->
          <template v-if="templateList && templateList.length > 0">
            <div
                v-for="item in templateList"
                :key="item.common_id"
                class="template-item"
                :class="{ active: selectedTemplate && selectedTemplate.common_id === item.common_id }"
                @click="handleTemplateClick(item)"
            >
              {{ item.phrases_desc }}
            </div>
          </template>

          <!-- 无数据 -->
          <div v-else class="template-empty">
            暂无数据
          </div>
        </div>
      </van-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  wxgetacupointallocationinfo,
  wxqryphydoctor,
  wxqryacupointtemp,
  wxsaveassignacupoint,
  wxsaveacupointtemp
} from "@/api/medical";
import {Toast} from "vant";

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        uname: {
            type: String,
            default: ''
        },
        usex: {
            type: String,
            default: ''
        },
        uage: {
            type: String,
            default: ''
        },
        uphone: {
            type: String,
            default: ''
        },
        serviceId: {
            type: String,
            default: ''
        },
        qryType: {
          type: Number,
          default: 1
        },
        qrydate: {
          type: String,
          default: ''
        },
        currentallpoints: {
          type: String,
          default: ''
        },
        currentAcupointData:{
          type: Array,
          default: () => []
        },
        userId: {
          type: Number,
          default: 1
        },
        customerId: {
          type: Number,
          default: 1
        },
        tCode: {
          type: String,
          default: '1'
        },
        hideAddDoctorButton: {
          type: Boolean,
          default: false
        },
    },
    computed: {
      ...mapGetters([
        'username','dispname','clinicid'
      ]),
    },
    data() {
        return {
            acupointText: '',
            mainPhysician: '',
            points: [],
            dataList: [],

            doctorDialogVisible: false,
            doctorList: [],
            selectedDoctorList: [],

            templateDialogVisible: false,
            templateList: [],
            selectedTemplate: null,

            saveToTemplate: false,
            templateKeyword: '',
            savedAcupointText: '',
        }
    },
    watch: {
      visible: {
        immediate: false,
        handler(val) {
          if (val) {
            this.getInfo()
          }
        }
      }
    },
    methods: {
        handleClose() {
          this.$emit('update:visible', false)
        },
        getInfo(){
          var res = new Promise((resolve)=>{
            let data = {
              data:this.currentAcupointData,
              serviceId:this.serviceId,
              allpoints:this.currentallpoints,
              userId:this.userId,
              customerId:this.customerId,
              tCode:this.tCode
            }

            wxgetacupointallocationinfo(data).then(response =>{
              resolve(response)
              if (response.response_body.flag){
                const responseBody = response.response_body || {}
                this.dataList = responseBody.data || []
                this.mainPhysician = ''
                this.acupointText = responseBody.points || ''
                this.markAcupointPlanSaved()
                this.refreshDoctorPointSelection(this.getResponseAllpoints(responseBody, this.currentallpoints))
              }

            }).catch((err) => {
                  // on cancel
                  resolve(err)
                  Toast.fail(err.response_head.retinfo.retmsg)
                });
          })
          return res
        },
        /**
         * 将接口或医生数据中的穴位内容统一转换为去重数组。
         */
        parsePointList(value) {
          if (Array.isArray(value)) {
            return Array.from(new Set(value.map(item => String(item).trim()).filter(Boolean)))
          }

          return Array.from(new Set(
              (value || '')
                  .split(/[,，、\s\n]+/)
                  .map(item => item.trim())
                  .filter(Boolean)
          ))
        },
        /**
         * 判断两个穴位列表是否为同一组穴位。
         */
        isSamePointList(leftList, rightList) {
          if (leftList.length !== rightList.length) {
            return false
          }

          return leftList.every(point => rightList.includes(point))
        },
        /**
         * 判断当前配穴方案是否已经保存并刷新到分工穴位列表。
         */
        isAcupointPlanSaved() {
          const inputPoints = this.parsePointList(this.acupointText)
          const savedPoints = this.parsePointList(this.savedAcupointText)

          return this.isSamePointList(inputPoints, savedPoints)
        },
        /**
         * 记录当前方案为已保存状态，用于保存分工前判断方案是否被改动。
         */
        markAcupointPlanSaved() {
          this.savedAcupointText = this.acupointText || ''
        },
        /**
         * 获取后端返回的医生分工穴位，兼容 allpoints 和 allPoints 两种字段。
         */
        getResponseAllpoints(responseBody, defaultValue) {
          if (responseBody && responseBody.allpoints !== undefined && responseBody.allpoints !== null) {
            return responseBody.allpoints
          }

          if (responseBody && responseBody.allPoints !== undefined && responseBody.allPoints !== null) {
            return responseBody.allPoints
          }

          return defaultValue
        },
        /**
         * 按后端返回的 allpoints 刷新医生可勾选穴位，并重新计算医生勾选状态。
         */
        refreshDoctorPointSelection(allpoints) {
          this.points = this.parsePointList(allpoints)
          this.initData()
        },
        initData() {
          this.dataList = Array.isArray(this.dataList) ? this.dataList : []
          let mainDoctor = null

          this.dataList.forEach(item => {
            // 保证 pointlist 是数组
            let list = this.parsePointList(item.pointlist)

            // 和 allpoints 对应的医生穴位列表做交集
            item.pointlist = this.points.filter(p => list.includes(p))

            // 初始化主理疗师
            if (item.ismain == 1) {
              this.mainPhysician = item.username
              mainDoctor = item
            }
          })

          this.assignUnselectedPointsToMainDoctor(mainDoctor)
          this.dataList = [...this.dataList]
        },
        /**
         * 将尚未分配的穴位默认勾选到主理疗师。
         */
        assignUnselectedPointsToMainDoctor(mainDoctor) {
          if (!mainDoctor || !this.points.length) {
            return
          }

          const assignedPoints = this.dataList.reduce((list, doctor) => {
            return list.concat(this.parsePointList(doctor.pointlist))
          }, [])
          const unselectedPoints = this.points.filter(point => !assignedPoints.includes(point))

          if (!unselectedPoints.length) {
            return
          }

          const mainDoctorPointList = this.parsePointList(mainDoctor.pointlist)
          mainDoctor.pointlist = this.points.filter(point => {
            return mainDoctorPointList.includes(point) || unselectedPoints.includes(point)
          })
        },
        deleteDoctor(index) {
            this.dataList.splice(index, 1)
        },
        isAllSelected(doctor) {
          return this.points.every(p =>
              doctor.pointlist.includes(p)
          )
        },
        toggleAll(doctor, index) {
          const isAll = this.isAllSelected(doctor)

          if (isAll) {
            doctor.pointlist = []
          } else {
            doctor.pointlist = [...this.points]

            // 清空其他人
            this.dataList.forEach((item, i) => {
              if (i !== index) item.pointlist = []
            })
          }

          this.dataList = [...this.dataList]
        },

        saveTemplateThenSaveAllocation(){
          console.log("this.saveToTemplate",this.saveToTemplate)
          if (!this.saveToTemplate) {
            this.handleSavePointsFromText()
            return
          }

          if (!this.acupointText || !this.acupointText.trim()) {
            Toast.fail('请先输入配穴方案')
            return
          }

          let data = {
            acupoint: this.acupointText.trim(),
            doctor: this.username
          }

          wxsaveacupointtemp(data).then(response => {
            if (response.response_body.flag) {
              this.handleSavePointsFromText()
            } else {
              Toast.fail('保存配穴模板失败')
            }
          }).catch(() => {
            Toast.fail('保存配穴模板失败')
          })
        },

        saveAcupointAllocation(){
          if (!this.isAcupointPlanSaved()) {
            Toast.fail('请先保存方案')
            return
          }

          if (this.qryType === 1){
            this.$emit('save', this.dataList,this.acupointText)
            // 关弹窗
            this.$emit('update:visible', false)

          }else if (this.qryType === 2){
            if (!this.dataList || this.dataList.length === 0) {
              Toast.fail('请添加执行人');
              return;
            }

            // 判断是否存在主理疗师
            const hasMainDoctor = this.dataList.some(item => item.ismain && item.ismain != 0);

            if (!hasMainDoctor) {
              Toast.fail('请设置主理疗师');
              return;
            }

            const assignedPoints = []

            this.dataList.forEach(item => {
              if (Array.isArray(item.pointlist)) {
                assignedPoints.push(...item.pointlist)
              }
            })

            const unassignedPoints = this.points.filter(point => !assignedPoints.includes(point))

            if (unassignedPoints.length > 0) {
              this.$dialog.confirm({
                title: '提示',
                message: '存在未分配穴位（' + unassignedPoints.join('、') + '），是否继续保存？'
              }).then(() => {
                this.doSaveAcupointAllocation()
              }).catch(() => {
                // 取消保存
              })

              return
            }

            this.doSaveAcupointAllocation()
          }
          console.log("list",this.dataList)
        },
        doSaveAcupointAllocation(){
          var res = new Promise((resolve) => {
            let data = {
              data: this.dataList,
              serviceId: this.serviceId,
              allPoints: this.acupointText.trim(),
              oprType: '2',
              username: this.username
            }

            wxsaveassignacupoint(data).then(response => {
              resolve(response)
              if (response.response_body.flag) {
                Toast.success('保存成功')

                this.$emit('save', this.dataList)
                this.$emit('update:visible', false)
              } else {
                Toast.fail('保存失败')
              }
            }).catch((err) => {
              resolve(err)
              Toast.fail('保存失败')
            })
          })

          return res
        },
        handleSavePointsFromText() {
          if (this.qryType == 2){
            if(!this.acupointText.trim()){
              Toast.fail('请输入配穴方案');
              return ;
            }
            let data = {
              data:this.dataList,
              serviceId:this.serviceId,
              allPoints:this.acupointText.trim(),
              oprType:'1',
              username: this.username
            }

            wxsaveassignacupoint(data).then(response =>{
              if (response.response_body.flag){
                Toast.success('保存成功')
                const responseBody = response.response_body || {}
                this.saveAllPoints(this.getResponseAllpoints(responseBody, ''));
              }else{
                Toast.fail('保存失败')
              }

            }).catch(() => {
              Toast.fail('保存失败')
            });
          }else{
            this.saveAllPoints();
          }
        },
        /**
         * 保存配穴方案后，根据后端返回的 allpoints 刷新医生勾选区域。
         */
        saveAllPoints(allpoints){
          const pointSource = arguments.length > 0 ? allpoints : this.acupointText
          this.refreshDoctorPointSelection(pointSource)
          this.markAcupointPlanSaved()
          this.$emit('plan-save')
        },
        handleMainChange(val){
          this.dataList.forEach(item => {
            item.ismain = (item.username == val) ? 1 : 0
          })
          console.log("---",this.dataList);
        },
        togglePoint(currentDoctor, point) {
          const index = currentDoctor.pointlist.indexOf(point)

          if (index > -1) {
            // 取消选中
            currentDoctor.pointlist.splice(index, 1)
          } else {
            // 选中

            // 先把其他医生的这个穴位干掉
            this.dataList.forEach(doctor => {
              if (doctor.username !== currentDoctor.username) {
                const i = doctor.pointlist.indexOf(point)
                if (i > -1) doctor.pointlist.splice(i, 1)
              }
            })

            // 再加到当前医生
            currentDoctor.pointlist.push(point)
          }

          // 强制更新
          this.dataList = [...this.dataList]
        },

        openDoctorDialog() {
          this.selectedDoctorList  = []
          this.doctorDialogVisible = true
          this.getDoctorList()
        },
        getDoctorList() {
          let data = {
            clinicId: this.clinicid,
            serviceId: this.serviceId,
            qrydate: this.qrydate
          }

          wxqryphydoctor(data).then(res => {
            if (res.response_body.flag) {
              this.doctorList = res.response_body.list || []
            }
          }).catch(() => {
            Toast.fail( '获取执行人失败')
          })
        },

        handleDoctorConfirm() {
          if (!this.selectedDoctorList.length) {
            Toast('请选择执行人')
            return
          }

          this.selectedDoctorList.forEach(item => {
            this.dataList.push({
              dispname: item.dispname,
              username: item.username,
              pointlist: [],
              ismain: 0,
              status: '0'
            })
          })

          this.doctorDialogVisible = false
        },
        // 是否已在 dataList（禁用）
        isDisabled(item) {
          return this.dataList.some(d => d.username === item.username)
        },

        // 是否当前选中
        isSelected(item) {
          return this.selectedDoctorList.some(
              d => d.username === item.username
          )
        },

        // 点击逻辑（关键）
        handleDoctorClick(item) {
          if (this.isDisabled(item)) return

          const index = this.selectedDoctorList.findIndex(
              d => d.username === item.username
          )

          // 已选中 -> 取消
          if (index > -1) {
            this.selectedDoctorList.splice(index, 1)
          } else {
            // 未选中 -> 添加
            this.selectedDoctorList.push(item)
          }
        },

        openTemplateDialog() {
          this.selectedTemplate = null
          this.templateDialogVisible = true
          this.getTemplateList()
        },

        getTemplateList() {
          let data = {
            username: this.username,
            keyword: this.templateKeyword
          }

          wxqryacupointtemp(data)
              .then(res => {
                if (res.response_body.flag) {
                  this.templateList = res.response_body.list || []
                }
              })
              .catch(() => {
                Toast.fail("获取模板失败")
              })
        },

        handleTemplateClick(item) {
          this.selectedTemplate = item
        },

        handleTemplateConfirm() {
          if (!this.selectedTemplate) {
            Toast("请选择模板")
            return
          }

          this.acupointText = this.selectedTemplate.phrases_desc
          this.templateDialogVisible = false
        },
        searchTemplate() {
          this.getTemplateList()
        },

    }
}
</script>

<style lang="scss" scoped>
::v-deep .acupoint-allocation-dialog {
    width: 90%;
    max-width: 400px;
    border-radius: 12px;
}

.dialog-close-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    color: #999;
    cursor: pointer;
    z-index: 10;
}


::v-deep .acupoint-allocation-dialog .van-dialog__header {
    font-size: 18px;
    font-weight: 600;
    padding: 16px 0;
}

.dialog-content {
    padding: 0 16px 16px;
    max-height: 70vh;
    overflow-y: auto;
}

.head{
  background-color: #CF8C57;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  padding: 15px;
  display: flex;
  align-items: flex-end;
  .text{
    margin-bottom: 10px;
    span{
      margin-right: 8px;
    }
  }
}

.period {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}

.left-info span {
    margin-right: 12px;
}

.right-info {
    font-size: 15px;
}

.acupoint-input-area {
    background-color: #F5F5F5;
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 16px;
    margin-top: -0.4rem;
}

.acupoint-textarea {
    width: 100%;
    border: none;
    background: transparent;
    font-size: 14px;
    resize: none;
    outline: none;
    min-height: 40px;
    margin-bottom: 12px;
}

.acupoint-display {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    margin-bottom: 12px;
}

.acupoint-tip {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #999;
}

.tip-icon {
    margin-right: 6px;
    font-size: 14px;
}

.btn-group {
    display: flex;
    gap: 12px;
}

.btn {
    flex: 1;
    height: 35px;
    border-radius: 18px;
    font-size: 14px;
    border: none;
    cursor: pointer;
    margin: 0 10px;
}

.btn-outline {
    background-color: #fff;
    border: 1px solid #C67C4A;
    color: #C67C4A;
}

.btn-primary {
    background: linear-gradient(135deg, #D4956A 0%, #C67C4A 100%);
    color: #fff;
}

.doctor-list {
    margin-bottom: 16px;
}

.doctor-item {
    margin-bottom: 20px;
}

.doctor-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.doctor-name-box{
  display: flex;
  gap:  10px;
}

.doctor-name {
    font-size: 14px;
    font-weight: 600;
    color: #333;
}

.delete-btn {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #EE0A23;
    cursor: pointer;
}

.delete-icon {
    margin-right: 4px;
}

::v-deep .main-physician-radio {
    margin-right: 0;
    font-size: 14px;
}

::v-deep .main-physician-radio .van-radio__label {
    font-size: 14px;
}

.acupoint-check-group {
    background-color: #F5F5F5;
    border-radius: 10px;
    padding: 12px;
}

.checkbox-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: center;
}

.checkbox-row ::v-deep .checkbox-group {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    font-size:14px;
}

::v-deep .checkbox-item {
    margin-right: 0;
    font-size:14px;
}

::v-deep .checkbox-item .van-checkbox__label,
::v-deep .van-checkbox .van-checkbox__label {
    font-size: 14px;
}

::v-deep .van-checkbox {
    font-size: 14px;
}

.bottom-btn-group {
    display: flex;
    gap: 12px;
}

.btn-large {
    height: 35px;
    border-radius: 24px;
    font-size: 14px;
}

.doctor-select-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
}

.doctor-select-item {
  padding: 8px 14px;
  border-radius: 20px;
  background: #f5f5f5;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s;
}

/* 选中态 */
.doctor-select-item.active {
  border-color: #C67C4A;
  color: #C67C4A;
  background: #fff;
}

/* 禁用态（已存在 dataList） */
.doctor-select-item.disabled {
  background: #eee;
  color: #bbb;
  cursor: not-allowed;
}

.template-dialog .template-list{
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
  padding: 10px;

  display: flex;
  gap: 10px;
  flex-direction: column;
}

.template-item {
  padding: 8px 14px;
  border-radius: 20px;
  background: #f5f5f5;
  font-size: 14px;
  cursor: pointer;
}

.template-item.active {
  background: #fff;
  color: #C67C4A;
  border: 1px solid #C67C4A;
}

.empty-doctor-tip{
  padding: 20px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
  width: 100%;
}

.save-template-row {
  margin-top: 5px;
  padding: 0 10px;
  font-size: 12px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.template-empty{
  color: #999;
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
}

.template-search {
  display: flex;
  align-items: center;
  padding: 10px;
  gap: 8px;
}

.template-search .van-field {
  flex: 1;
}
</style>
